"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionTypes = exports.FilterTypes = exports.PathDirection = exports.QueryTypes = void 0;
var QueryTypes;
(function (QueryTypes) {
    QueryTypes["simplePath"] = "SIMPLE_PATH";
    QueryTypes["directedPath"] = "DIRECTED_PATH";
    QueryTypes["filteredGet"] = "FILTERED_GET";
    QueryTypes["searchByType"] = "SEARCH_BY_TYPE";
    QueryTypes["LIST_LIMITED_ALL_TYPES"] = "LIST_LIMITED_ALL_TYPES";
})(QueryTypes || (exports.QueryTypes = QueryTypes = {}));
var PathDirection;
(function (PathDirection) {
    PathDirection["parent"] = "PARENT";
    PathDirection["child"] = "CHILD";
})(PathDirection || (exports.PathDirection = PathDirection = {}));
var FilterTypes;
(function (FilterTypes) {
    FilterTypes["simpleAnd"] = "SIMPLE_AND";
})(FilterTypes || (exports.FilterTypes = FilterTypes = {}));
var ConditionTypes;
(function (ConditionTypes) {
    ConditionTypes["between"] = "BETWEEN";
    ConditionTypes["beginsWIth"] = "BEGINS_WITH";
    ConditionTypes["contains"] = "CONTAINS";
    ConditionTypes["equals"] = "=";
    ConditionTypes["notEquals"] = "<>";
    ConditionTypes["and"] = "and";
})(ConditionTypes || (exports.ConditionTypes = ConditionTypes = {}));
